var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card white-card shadow-sm" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("h4", { staticClass: "card-title mb-3" }, [
        _vm._v("Manage Account Subscription"),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "row small-card-content" }, [
          _c("div", { staticClass: "col-9" }, [
            _c("div", { staticClass: "align-items-center" }, [
              _vm._v(
                "\n                        All Customily billing and subscription actions are managed on your Shopify Apps and Sales\n                        Channels section, whether you want to view your invoices or uninstall the app from\n                        yourShopify store. For extra guidance, see our\n                        "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: _setup.customilyHelpLink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v("Help Center")]
              ),
              _vm._v(".\n                    "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col d-flex align-items-end justify-content-end" },
            [
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    href: _setup.adminShopifyLink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [
                  _vm._v("Manage Subscriptions "),
                  _c("font-awesome-icon", {
                    attrs: { icon: ["far", "arrow-up-right-from-square"] },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }